module.exports = __webpack_public_path__ + "img/rooming-list.90fcafa0.svg";